import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { MechanismSection } from './components/MechanismSection';
import { VisionSection } from './components/VisionSection';
import { GymGallery } from './components/GymGallery';
import { FeaturesSection } from './components/FeaturesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { StepsSection } from './components/StepsSection';
import { CtaSection } from './components/CtaSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
export function App() {
  return <div className="min-h-screen bg-gym-dark font-body text-white selection:bg-gym-green selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <FloatingNotification data-id="element-2" />
      <main data-id="element-3">
        <div id="inicio" data-id="element-4">
          <HeroSection data-id="element-5" />
        </div>
        <div id="problema" data-id="element-6">
          <PainSection data-id="element-7" />
          <TruthSection data-id="element-8" />
        </div>
        <div id="metodo" data-id="element-9">
          <MechanismSection data-id="element-10" />
        </div>
        <div id="resultados" data-id="element-11">
          <VisionSection data-id="element-12" />
          <GymGallery data-id="element-13" />
        </div>
        <div id="ubicacion" data-id="element-14">
          <FeaturesSection data-id="element-15" />
        </div>
        <div id="oferta" data-id="element-16">
          <OfferSection data-id="element-17" />
          <GuaranteeSection data-id="element-18" />
          <UrgencySection data-id="element-19" />
          <StepsSection data-id="element-20" />
        </div>
        <div id="contacto" data-id="element-21">
          <CtaSection data-id="element-22" />
        </div>
        <div id="faq" data-id="element-23">
          <FaqSection data-id="element-24" />
        </div>
      </main>
      <Footer data-id="element-25" />
    </div>;
}